import type { TreatmentViewModel } from "@/hooks/matter-view-models/use-medical-treatment-view-model";

type AppointmentBill =
  TreatmentViewModel["appointments"][number]["bills"][number];
type AppointmentRecord =
  TreatmentViewModel["appointments"][number]["records"][number];

export const getItemStatus = (item: AppointmentBill | AppointmentRecord) =>
  "recordStatus" in item ? item.recordStatus : item.status;

export const getItemDateModified = (
  item: AppointmentBill | AppointmentRecord,
) => item.dateModified;

export const getItemRequestDate = (
  item: AppointmentBill | AppointmentRecord,
) => ("recordStatus" in item ? item.recordRequestDate : item.requestDate);

export const getItemReceivedDate = (
  item: AppointmentBill | AppointmentRecord,
) => ("recordStatus" in item ? item.recordReceivedDate : item.receivedDate);

export const getItemRejectedDate = (
  item: AppointmentBill | AppointmentRecord,
) => ("recordStatus" in item ? item.recordRejectedDate : item.rejectedDate);
